import { ClientReportSettingsService } from '../features/assessments-v2/services/ClientReportSettingsService';
import {
  assertClinicTimeZoneMatches,
  ClinicTimeZoneUnavailableError,
} from '../utils/clinicTimeZoneWriteGuard';

export class ClinicTimeZoneService {
  /**
   * Relê o fuso persistido antes de uma escrita temporal. A comparação impede
   * que um formulário aberto em um fuso antigo grave o horário segundo outro.
   */
  static async requireCurrentForWrite(
    clientId: string,
    displayedTimeZone: unknown,
  ): Promise<string> {
    if (!clientId) {
      throw new ClinicTimeZoneUnavailableError();
    }

    let currentTimeZone: string;
    try {
      currentTimeZone = await ClientReportSettingsService.getTimeZoneByClientId(clientId);
    } catch (error) {
      console.error('Não foi possível validar o fuso horário da clínica antes da gravação:', error);
      throw new ClinicTimeZoneUnavailableError(
        'Não foi possível confirmar o fuso horário da clínica. Nenhuma alteração temporal foi salva. Tente novamente.',
      );
    }

    return assertClinicTimeZoneMatches(displayedTimeZone, currentTimeZone);
  }
}
